import React, { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';

import "./CDragAndDrop.css";
import UploadImage from '@/assets/images/upload_image.svg'
import CIconButton from './CIconButton';

const CDragAndDrop = (props) => {
    const [files, setFiles] = useState([]);
    const [dragNDropStates, setDragNDropStates] = useState({
        showPreview: true,
        showPreviewInDropzone: false,
        maxFiles: 0, // 0 for unlimited
        acceptedFiles: { ['image/*']: [] },
        showFileNames: false,
    });

    useEffect(() => {
        // if (props.showPreview === undefined) return;
        setDragNDropStates((prevOptions) => ({
            ...prevOptions,
            showPreview: props.showPreview !== undefined ? props.showPreview : true,
            showPreviewInDropzone: props.showPreviewInDropzone !== undefined ? props.showPreviewInDropzone : false,
            maxFiles: props.maxFiles !== undefined ? props.maxFiles : 0,
            acceptedFiles: props.acceptedFiles !== undefined ? props.acceptedFiles : dragNDropStates.acceptedFiles,
            showFileNames: props.showFileNames !== undefined ? props.showFileNames : false,
        }));
    }, [props.showPreview, props.showPreviewInDropzone, props.maxFiles, props.acceptedFiles]);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        accept: dragNDropStates.acceptedFiles,
        maxFiles: dragNDropStates.maxFiles,
        onDrop: acceptedFiles => {
            const updatedFiles = acceptedFiles.map((file) =>
                Object.assign(file, {
                    preview: URL.createObjectURL(file),
                })
            );

            if (dragNDropStates.maxFiles === 1) {
                setFiles([...updatedFiles]);
            } else {
                setFiles([...files, ...updatedFiles]);
            }

            props.onFileAdd(updatedFiles);
        }
    });

    const handleRemove = (file) => {
        const updatedFiles = [...files];
        updatedFiles.map((item, index) => {
            if (item.name === file.name) {
                updatedFiles.splice(index, 1);
                URL.revokeObjectURL(file.preview);
            }
            return {
                category: item.category,
                image: item.image,
            }
        })

        props.onFileRemove(file);
        setFiles(updatedFiles);
    };

    // Getting the preview images
    const thumbs = files.map((file, index) => (
        <div className='thumbnail-outer' key={index}>
            <div className='thumbnail'>
                <div className='thumbnail-inner'>
                    <img
                        src={file.preview}
                        className='preview-image'
                        alt={file.name}
                    // Revoke data uri after image is loaded
                    // onLoad={() => { URL.revokeObjectURL(file.preview) }}
                    />

                </div>
            </div>
            <CIconButton className="remove-icon" icon="close" onClick={() => handleRemove(file)} />
        </div>
    ));

    const fileNameDisplay = () => {
        return files.map((file, index) => (
            <div className={`file-name-display`} key={index}>
                <div className='file-name-content'>
                    <div className='file-name-info'>
                        <span>{file.name}</span>
                    </div>
                </div>

                <div className='file-name-action-icons'>
                    <CIconButton className="remove-icon" icon="close" onClick={() => handleRemove(file)} />
                </div>
            </div>
        ));
    }


    useEffect(() => {
        if (props.deleteAllImages) {
            setFiles([]);
            props.resetDeleteAllImages();
        }

        return () => {
            // Make sure to revoke the data uris to avoid memory leaks
            files.forEach(file => URL.revokeObjectURL(file.preview));
        }
    }, [props.deleteAllImages])

    return (
        <div className='drag-n-drop'>
            <div className={`drag-n-drop-container ${isDragActive ? 'drag-active' : ''}`} {...getRootProps()}>
                <input {...getInputProps()} />
                <div className={`empty-state-text`}>
                    <img src={UploadImage} alt="upload" className='upload-image' />
                    <span className='title-text text-4'>{'Drag your file or '} <a>{'browse'}</a></span>
                    <span className='text-5'>{'Max 10 MB files are allowed'}</span>
                </div>
            </div>
            {(dragNDropStates.showPreview || dragNDropStates.showFileNames) && files.length > 0 ?
                <div className='preview-container'>
                    {/* <span className='text-4'>{'Preview'}</span> */}
                    <aside className='preview-thumbnail-container'>
                        {dragNDropStates.showPreview ? thumbs : fileNameDisplay()}
                    </aside>
                </div>
                :
                null
            }
        </div>
    )
}

export default CDragAndDrop;